import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import Information from './components/show/Information';
import AddressInformation from './components/show/AddressInformation';
import LineItems from './components/show/LineItems';
import Shipments from './components/show/Shipments';
import ShowContainer from '../../shared/components/show/ShowContainer';

const ShowIndex = () => (
  <Container>
    <ShowContainer>
      <Information />
      <hr />
      <AddressInformation />
      <hr />
      <LineItems />
      <hr />
      <Shipments />
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(ShowIndex));
